/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "calendar-3e242564--sprite",
  "use": "calendar-3e242564--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"calendar-3e242564--sprite\">\r\n  <defs>\r\n    <clipPath id=\"calendar-3e242564--sprite_clip-Notification_New_Sale_Date\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"calendar-3e242564--sprite_Notification_New_Sale_Date\" data-name=\"Notification_New Sale Date\" clip-path=\"url(#calendar-3e242564--sprite_clip-Notification_New_Sale_Date)\">\r\n    <rect id=\"calendar-3e242564--sprite_Rectangle_10689\" data-name=\"Rectangle 10689\" width=\"36\" height=\"36\" fill=\"none\" />\r\n    <g id=\"calendar-3e242564--sprite_Group_19966\" data-name=\"Group 19966\" transform=\"translate(8.471 7.529)\">\r\n      <path id=\"calendar-3e242564--sprite_Path_4187\" data-name=\"Path 4187\" d=\"M426,399.392v8.471a2.124,2.124,0,0,0,2.118,2.118h14.824a2.124,2.124,0,0,0,2.118-2.118v-8.471A1.059,1.059,0,0,0,444,398.333H427.059A1.059,1.059,0,0,0,426,399.392Zm16.941,7.412a1.062,1.062,0,0,1-1.059,1.059h-2.118a1.062,1.062,0,0,1-1.059-1.059v-2.118a1.062,1.062,0,0,1,1.059-1.059h2.118a1.062,1.062,0,0,1,1.059,1.059Z\" transform=\"translate(-426 -391.98)\" fill=\"currentColor\" />\r\n      <path id=\"calendar-3e242564--sprite_Path_4188\" data-name=\"Path 4188\" d=\"M445.059,395.51v1.059A1.059,1.059,0,0,1,444,397.627H427.059A1.059,1.059,0,0,1,426,396.568V395.51a1.062,1.062,0,0,1,1.059-1.059h3.706v-1.588a.529.529,0,0,1,1.059,0v1.588h7.412v-1.588a.529.529,0,0,1,1.059,0v1.588H444A1.062,1.062,0,0,1,445.059,395.51Z\" transform=\"translate(-426 -392.333)\" fill=\"currentColor\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
